import { AxiosInstance } from "axios";
import { CreateCustomerUrlDto } from "../types/customer-url.type";

export const CustomerUrlService = (axiosInstance: AxiosInstance) => {
  const apiBaseUrl = "api/customer-url";

  return {
    create: async (data: CreateCustomerUrlDto) => {
      return await axiosInstance.post(`${apiBaseUrl}`, data).then((result) => result.data);
    },
    getOneCustomerId: async (customerId: string, agendaId: string) => {
      const params = { agendaId: agendaId };
      return await axiosInstance.get(`${apiBaseUrl}/customer/${customerId}`, { params }).then((result) => result.data);
    },
    countCustomerId: async (customerId: string, agendaId: string) => {
      const params = { agendaId: agendaId };
      return await axiosInstance.get(`${apiBaseUrl}/customer/count/${customerId}`, { params }).then((result) => result.data);
    },
    getAll: async (eventId: string, skip: number, take: number) => {
      const params = { eventId: eventId, skip: skip, take: take };
      return await axiosInstance.get(`${apiBaseUrl}`, { params }).then((result) => result.data);
    },
    getDropDown: async () => {
      return await axiosInstance.get(`${apiBaseUrl}/dropDown`).then((result) => result.data);
    },
    delete: async (id: number) => {
      return await axiosInstance.delete(`${apiBaseUrl}/${id}`).then((result) => result.data);
    },
    update: async (id: number, data: CreateCustomerUrlDto) => {
      return await axiosInstance.patch(`${apiBaseUrl}/${id}`, data).then((result) => result.data);
    },
  };
};
